
import ConsultaReclamacionesModel from "@/models/ConsultaReclamaciones/ConsultaReclamacionesModel";
import UmbracoApiService from "@/services/UmbracoApiService";
import { Component, Prop, Vue } from "vue-property-decorator";
import ComplaintResponse from "@/models/ConsultaReclamaciones/ComplaintResponse";

@Component({})
export default class ConsultaReclamacionesResult extends Vue {
    @Prop() complaints: Array<ComplaintResponse>;

    public process() {
        this.$emit("process");
    }
}
